import app from 'flarum/forum/app';
function base() {
  return app.forum.attribute('apiUrl') + '/giveaways';
}
export function listGiveaways() {
  return app.request({
    method: 'GET',
    url: base()
  });
}
export function showGiveaway(idOrSlug) {
  return app.request({
    method: 'GET',
    url: "".concat(base(), "/").concat(idOrSlug)
  });
}
export function enterGiveaway(id) {
  return app.request({
    method: 'POST',
    url: "".concat(base(), "/").concat(id, "/enter")
  });
}
export function drawGiveaway(id) {
  return app.request({
    method: 'POST',
    url: "".concat(base(), "/").concat(id, "/draw")
  });
}
export function claimGiveaway(id) {
  return app.request({
    method: 'POST',
    url: "".concat(base(), "/").concat(id, "/claim")
  });
}
export function deleteGiveaway(id) {
  return app.request({
    method: 'DELETE',
    url: "".concat(base(), "/").concat(id)
  });
}
export function saveGiveaway(attributes, id) {
  return app.request({
    method: id ? 'PATCH' : 'POST',
    url: id ? "".concat(base(), "/").concat(id) : base(),
    body: {
      data: {
        attributes
      }
    }
  });
}
function catBase() {
  return app.forum.attribute('apiUrl') + '/giveaway-categories';
}
export function listCategories() {
  return app.request({
    method: 'GET',
    url: catBase()
  });
}
export function saveCategory(attributes, id) {
  return app.request({
    method: id ? 'PATCH' : 'POST',
    url: id ? "".concat(catBase(), "/").concat(id) : catBase(),
    body: {
      data: {
        attributes
      }
    }
  });
}
export function deleteCategory(id) {
  return app.request({
    method: 'DELETE',
    url: "".concat(catBase(), "/").concat(id)
  });
}
flarum.reg.add('ernestdefoe-giveaways', 'common/api', { listGiveaways: listGiveaways,showGiveaway: showGiveaway,enterGiveaway: enterGiveaway,drawGiveaway: drawGiveaway,claimGiveaway: claimGiveaway,deleteGiveaway: deleteGiveaway,saveGiveaway: saveGiveaway,listCategories: listCategories,saveCategory: saveCategory,deleteCategory: deleteCategory, });